/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'
import * as AdminDefs from '../../../com/atproto/admin/defs.defs.js'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs.js'

const $nsid = 'tools.ozone.moderation.emitEvent'

export { $nsid }

/** Take a moderation action on an actor. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    event: l.typedUnion(
      [
        l.typedRef<ModerationDefs.ModEventTakedown>(
          (() => ModerationDefs.modEventTakedown) as any,
        ),
        l.typedRef<ModerationDefs.ModEventAcknowledge>(
          (() => ModerationDefs.modEventAcknowledge) as any,
        ),
        l.typedRef<ModerationDefs.ModEventEscalate>(
          (() => ModerationDefs.modEventEscalate) as any,
        ),
        l.typedRef<ModerationDefs.ModEventComment>(
          (() => ModerationDefs.modEventComment) as any,
        ),
        l.typedRef<ModerationDefs.ModEventLabel>(
          (() => ModerationDefs.modEventLabel) as any,
        ),
        l.typedRef<ModerationDefs.ModEventReport>(
          (() => ModerationDefs.modEventReport) as any,
        ),
        l.typedRef<ModerationDefs.ModEventMute>(
          (() => ModerationDefs.modEventMute) as any,
        ),
        l.typedRef<ModerationDefs.ModEventUnmute>(
          (() => ModerationDefs.modEventUnmute) as any,
        ),
        l.typedRef<ModerationDefs.ModEventMuteReporter>(
          (() => ModerationDefs.modEventMuteReporter) as any,
        ),
        l.typedRef<ModerationDefs.ModEventUnmuteReporter>(
          (() => ModerationDefs.modEventUnmuteReporter) as any,
        ),
        l.typedRef<ModerationDefs.ModEventReverseTakedown>(
          (() => ModerationDefs.modEventReverseTakedown) as any,
        ),
        l.typedRef<ModerationDefs.ModEventResolveAppeal>(
          (() => ModerationDefs.modEventResolveAppeal) as any,
        ),
        l.typedRef<ModerationDefs.ModEventEmail>(
          (() => ModerationDefs.modEventEmail) as any,
        ),
        l.typedRef<ModerationDefs.ModEventDivert>(
          (() => ModerationDefs.modEventDivert) as any,
        ),
        l.typedRef<ModerationDefs.ModEventTag>(
          (() => ModerationDefs.modEventTag) as any,
        ),
        l.typedRef<ModerationDefs.AccountEvent>(
          (() => ModerationDefs.accountEvent) as any,
        ),
        l.typedRef<ModerationDefs.IdentityEvent>(
          (() => ModerationDefs.identityEvent) as any,
        ),
        l.typedRef<ModerationDefs.RecordEvent>(
          (() => ModerationDefs.recordEvent) as any,
        ),
        l.typedRef<ModerationDefs.ModEventPriorityScore>(
          (() => ModerationDefs.modEventPriorityScore) as any,
        ),
        l.typedRef<ModerationDefs.AgeAssuranceEvent>(
          (() => ModerationDefs.ageAssuranceEvent) as any,
        ),
        l.typedRef<ModerationDefs.AgeAssuranceOverrideEvent>(
          (() => ModerationDefs.ageAssuranceOverrideEvent) as any,
        ),
        l.typedRef<ModerationDefs.AgeAssurancePurgeEvent>(
          (() => ModerationDefs.ageAssurancePurgeEvent) as any,
        ),
        l.typedRef<ModerationDefs.RevokeAccountCredentialsEvent>(
          (() => ModerationDefs.revokeAccountCredentialsEvent) as any,
        ),
        l.typedRef<ModerationDefs.ScheduleTakedownEvent>(
          (() => ModerationDefs.scheduleTakedownEvent) as any,
        ),
        l.typedRef<ModerationDefs.CancelScheduledTakedownEvent>(
          (() => ModerationDefs.cancelScheduledTakedownEvent) as any,
        ),
      ],
      false,
    ),
    subject: l.typedUnion(
      [
        l.typedRef<AdminDefs.RepoRef>((() => AdminDefs.repoRef) as any),
        l.typedRef<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
      ],
      false,
    ),
    subjectBlobCids: l.optional(l.array(l.string({ format: 'cid' }))),
    createdBy: l.string({ format: 'did' }),
    modTool: l.optional(
      l.ref<ModerationDefs.ModTool>((() => ModerationDefs.modTool) as any),
    ),
    externalId: l.optional(l.string()),
  }),
  l.payload(
    'application/json',
    l.ref<ModerationDefs.ModEventView>(
      (() => ModerationDefs.modEventView) as any,
    ),
  ),
  ['SubjectHasAction', 'DuplicateExternalId'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
